module.exports = __webpack_public_path__ + "assets/signout_primary.fe5efea8.svg";